import { useConfirmStore } from "@/hooks/useConfirm";
import { ConfirmDialog } from "./ConfirmDialog";

export function ConfirmDialogProvider() {
  const { open, options, handleConfirm, handleCancel } = useConfirmStore();

  if (!options) return null;

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(isOpen) => {
        if (!isOpen) handleCancel();
      }}
      title={options.title}
      message={options.message}
      confirmLabel={options.confirmLabel}
      cancelLabel={options.cancelLabel}
      variant={options.variant}
      onConfirm={handleConfirm}
    />
  );
}
